import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const adminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.getUser();
  
  // Check if user is logged in and is admin
  if (user && user.isAdmin) {
    return true;
  }

  // Redirect to admin login with return URL
  const returnUrl = state.url;
  router.navigate(['/admin-login'], {
    queryParams: { returnUrl }
  });
  
  return false;
};

